// Château Corset : points des cartes qui se font glisser, et toucher simple qui ouvre la fiche (voir cc-glisser.css).
(function () {
  if (window.__ccGlisser) return;
  window.__ccGlisser = true;

  // Le défilement ne remonte pas d'un élément à l'autre : on l'écoute en phase de capture, une fois pour toutes les cartes.
  document.addEventListener('scroll', function (e) {
    var bande = e.target;
    if (!bande.classList || !bande.classList.contains('cc-glisser')) return;
    var rang = Math.round(bande.scrollLeft / bande.clientWidth);
    bande.parentElement.querySelectorAll('.cc-glisser__points > span').forEach(function (point, i) {
      point.classList.toggle('is-active', i === rang);
    });
  }, true);

  // Cartes du thème : l'image est passée au-dessus du lien, elle doit donc ouvrir la fiche elle-même.
  document.addEventListener('click', function (e) {
    var bande = e.target.closest && e.target.closest('.card__media > .cc-glisser');
    if (!bande) return;
    var lien = bande.closest('.card-wrapper') && bande.closest('.card-wrapper').querySelector('.card__heading a');
    if (lien) window.location.href = lien.href;
  });

})();
